import Main from './Main.vue'

export default [{
  path: 'relatorios/gerencial',
  name: 'relatorios-gerencial',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/routes.js